import { FC } from 'react';

import dayjs from 'dayjs';
import { Entry } from 'ui/components/common';
import { ENTRY_TYPE } from 'ui/components/common/Entry/Entry';
import { useGetLogs } from 'modules/account/contact/hooks';
import { Logs } from 'utils/types';

const Activity: FC<{ id: string }> = ({ id }) => {
  const { data } = useGetLogs('companies', id);

  return (
    <div className="max-h-[calc(100vh-299px)] overflow-y-auto">
      {!data?.length ? (
        <p className="mb-[14px] text-sm leading-5">No Activity recorded</p>
      ) : (
        data?.map(({ date, logs }) => (
          <div key={Math.random()}>
            <div className="font-semibold text-[14px] text-secondary-dark mb-5">
              {dayjs.unix(date).format('MMMM YYYY')}
            </div>
            {logs.map((log: Logs) => (
              <Entry
                key={Math.random()}
                data={log}
                type={ENTRY_TYPE.ACTIVITY}
              />
            ))}
          </div>
        ))
      )}
    </div>
  );
};

export default Activity;
